import { useState } from 'react';
import { Button, Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { columns } from './grid-columns';
import { EquipmentForm } from './equipment.form';
import { Equipment } from '../../../models/masters/equipment';
import { equipmentFormSchema } from './equipment-form.schema';
import { SiTrackGrid } from '../../../components/si-track-grid/si-track-grid';
import { SaveHookFormDialog } from '../../../components/save-hook-form.dialog';
import { equipmentApiKeyStore } from '../../../api/masters/equipment-api-key-store';
import { SiTrackPage } from '../../../components/si-track-page';
import { UserPermissionName } from '../../../models/user-permission-name';
import { GuardedComponent } from '../../../components/guarded-component';
import { CustomGridCell } from './custom-grid-cell';

const styling = {
  paperStyle: { padding: '20px', borderRadius: '20px' },
};

export const EquipmentsPage = () => {
  const [editItem, setEditItem] = useState<Partial<Equipment>>();

  const handleEditEquipment = (equipment: Equipment) => {
    setEditItem(equipment);
  };
  const handleEditClose = () => {
    setEditItem(undefined);
  };
  const handleCreateEquipment = () => {
    setEditItem({ status: "active" });
  };

  const formatSubmitdata = (data: any) => {
    return {
      ...data,
      purchasedOn: data?.purchasedOn ? new Date(data?.purchasedOn) : null,
    };
  };

  return (
    <SiTrackPage
      title="Equipments"
      actionButton={
        <GuardedComponent requiredPermissions={[UserPermissionName.ADD_EQUIPMENT]}>
          <Button
            size="small"
            variant="contained"
            disableElevation={true}
            startIcon={<AddIcon />}
            onClick={handleCreateEquipment}
          >
            Add Equipment
          </Button>
        </GuardedComponent>
      }
    >
      <Paper elevation={0} style={styling.paperStyle}>
        <SiTrackGrid
          fileTitle='equipment'
          dataItemKey="equipmentID"
          columns={columns}
          customCell={(field) =>
            CustomGridCell({
              field,
            })
          }
          queryConfig={equipmentApiKeyStore.getEquipments()}
          viewRoute={(equipment) => `/equipments/${equipment.equipmentID}`}
          onEdit={handleEditEquipment}
          deleteMutationConfig={(deleteItem) => equipmentApiKeyStore.deleteEquipment(deleteItem.equipmentID)}
          actionPermissions={{
            edit: UserPermissionName.EDIT_EQUIPMENT,
            delete: UserPermissionName.DELETE_EQUIPMENT,
            export: UserPermissionName.DOWNLOAD_GRID
          }}
        />
        {editItem && (
          <SaveHookFormDialog
            title={editItem.equipmentID ? 'UPDATE EQUIPMENT' : 'CREATE EQUIPMENT'}
            config={{
              saveConfig: editItem.equipmentID
                ? equipmentApiKeyStore.updateEquipment()
                : equipmentApiKeyStore.createEquipment(),
              invalidateRoute: () => equipmentApiKeyStore.getEquipments(),
            }}
            data={editItem}
            yupSchema={equipmentFormSchema}
            formatSubmitdata={formatSubmitdata}
            onClose={handleEditClose}
            size="md"
          >
            <EquipmentForm />
          </SaveHookFormDialog>
        )}
      </Paper>
    </SiTrackPage>
  );
};
